var core = module.exports = {
  version: '2.6.1'
};
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef